export const isObject = obj => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

/** Encode object to url parameters */
export const objectToParams = (obj) => {
  if (!isObject(obj) || Object.keys(obj).length === 0) {
    return '';
  }

  return (
    '?' +
    Object.keys(obj)
      .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
      .join('&')
  );
};

/** Decode params to object */
export const paramsToObject = (params) =>
  params
    ?.replace(/^\?/, '')
    .split('&')
    .reduce((acc, chunk) => {
      if (!chunk) {
        return acc;
      }

      const [key, value] = chunk.split('=');
      return { ...acc, [key]: decodeURIComponent(value) };
    }, {}) || {};
